module.exports = __webpack_public_path__ + "static/img/3.59d7e18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/附件八/3.jpg
// module id = FcQ8
// module chunks = 1